import React, { useContext } from 'react';
import SspContext from '../../../contexts/SspContext';
import { menuItems } from '../../../constants/menuItems';
import { useTranslation } from 'react-i18next'

interface ISeeAll {
	isOverview: boolean
	showMore: Function
	hideShowMore: boolean
}

export const SeeAll = ({ isOverview, showMore, hideShowMore }: ISeeAll) => {
	const { t } = useTranslation()
	const { changeComponent } = useContext(SspContext)
	if (isOverview) {
		return (
			<div
				className="change-component pointer"
				onClick={() => changeComponent(menuItems[0].items[2])}>
				{t('SeeAll')}
				<span className="chevron-right ml-1"></span>
			</div>
		)
	} else {
		return (
			<>
				{hideShowMore && (
					<div
						className="change-component pointer"
						onClick={() => showMore()}>
						{t('ShowMore')}
					</div>
				)}
			</>
		)
	}
}
export default SeeAll